function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const prototype: unknown = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

/*
  Structured cloning throws DataCloneError on Proxy objects, such as the Vue 3
  reactive state that UI code builds worker messages from. This copies arrays and
  plain objects recursively, reading through any proxy, so the copy holds none.
  Other objects (ArrayBuffer, typed arrays, OffscreenCanvas) are kept by reference,
  so a transfer list still refers to objects inside the copy. Messages must be
  acyclic.
*/
export function proxyFreeCopy<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(proxyFreeCopy) as T;
  }
  if (isPlainObject(value)) {
    return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, proxyFreeCopy(entry)])) as T;
  }
  return value;
}
